<section class="contacts-container">
  <header class="contacts-header">
    <div>
      <h2>Контакты пользователя</h2>
      <p>Подтверждённые и ожидающие подтверждения email и телефоны.</p>
    </div>

    <mat-checkbox [(ngModel)]="includeRevoked" (change)="reload()">
      Показывать отозванные
    </mat-checkbox>
  </header>

  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

  <div *ngIf="hasError" class="contacts-message contacts-message--error">
    Не удалось загрузить контакты.
    <button mat-button color="primary" type="button" (click)="reload()">Повторить</button>
  </div>

  <div *ngIf="!isLoading && !hasError && contacts.length === 0" class="contacts-message">
    Контакты отсутствуют.
  </div>

  <div *ngIf="!hasError && contacts.length > 0" class="contacts-table-wrapper">
    <table mat-table [dataSource]="contacts" class="contacts-table">
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Тип</th>
        <td mat-cell *matCellDef="let contact">{{ getTypeLabel(contact.type) }}</td>
      </ng-container>

      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef>Адрес</th>
        <td mat-cell *matCellDef="let contact" class="contact-address">{{ contact.address }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Статус</th>
        <td mat-cell *matCellDef="let contact">
          <span class="contact-status contact-status--{{ contact.status }}">
            {{ getStatusLabel(contact.status) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="verifiedAt">
        <th mat-header-cell *matHeaderCellDef>Подтверждён</th>
        <td mat-cell *matCellDef="let contact">
          {{ contact.verifiedAt ? (contact.verifiedAt | date:'dd.MM.yyyy HH:mm') : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>Добавлен</th>
        <td mat-cell *matCellDef="let contact">{{ contact.createdAt | date:'dd.MM.yyyy HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="revokedAt">
        <th mat-header-cell *matHeaderCellDef>Отозван</th>
        <td mat-cell *matCellDef="let contact">
          {{ contact.revokedAt ? (contact.revokedAt | date:'dd.MM.yyyy HH:mm') : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="copy">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let contact">
          <button mat-icon-button type="button" [cdkCopyToClipboard]="contact.address" matTooltip="Скопировать">
            <mat-icon>content_copy</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</section>
